// extracted by mini-css-extract-plugin
export default {"card":"styles_card__RFI4A","busBox":"styles_busBox__Mxf9a","timeBox":"styles_timeBox__2EQT5"};